import { ref } from 'vue';
import { nanoid } from 'nanoid';
import mediaProvider, { UploadParams } from '@/data-provider/mediaProvider';

const useUploadMedia = () => {
  const uploadInProgress = ref(false);

  const upload = (id: string, data: File, params: UploadParams = {}): Promise<void> => {
    uploadInProgress.value = true;

    return mediaProvider
      .uploadMedia(id, data, params)
      .then(() => {
        uploadInProgress.value = false;
      })
      .catch(() => {
        uploadInProgress.value = false;
      });
  };

  const uploadBulk = (id: string, data: File[], params: UploadParams = {}, pip?: boolean): Promise<void> => {
    uploadInProgress.value = true;

    if (pip === true) {
      // eslint-disable-next-line no-param-reassign
      params.uploadId = nanoid(5).concat('_pip');
    } else {
      // eslint-disable-next-line no-param-reassign
      params.uploadId = nanoid(5);
    }
    return Promise.all(data.map((file) => mediaProvider.uploadMedia(id, file, params)))
      .then(() => {
        uploadInProgress.value = false;
      })
      .catch(() => {
        uploadInProgress.value = false;
      });
  };

  return {
    uploadInProgress,
    upload,
    uploadBulk,
  };
};

export default useUploadMedia;
